export default "__VITE_ASSET__BLyCe_jI__"